import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject ,  Subscription } from 'rxjs';
import { LocalStorage, SessionStorage } from 'ngx-webstorage';

import { MenuLinkModel } from '../models/menu-link.model';
import { Session } from 'protractor';

export const MENU_LINKS: MenuLinkModel[] = [
  { icon: 'icon-chart', title: 'Dashboard', path: ['/dashboard'], badge: '' },
]

@Injectable()
export class NavMenuService extends BehaviorSubject<MenuLinkModel[]> {

  constructor() {
    super([]);
    this.getMenuItems();
    super.next(MENU_LINKS);
  }

  getAppVersion(): string {
    var app_version: string = sessionStorage.getItem('SCE_Platform|app_version');
    // Remove the double quotes
    if (app_version != null) {
      return app_version.substring(1, app_version.length - 1);
    }
  }

  setAppVersion(appVersion: string): void {
    sessionStorage.setItem('SCE_Platform|app_version', appVersion);
  }

  getAppEnvironment(): string {
    var app_environment: string = sessionStorage.getItem('SCE_Platform|app_environment');

    // Remove the double quotes
    if (app_environment != null) {
      app_environment = app_environment.substring(1, app_environment.length - 1);
    }

    return app_environment;
  }

  getMenuItems(): void {
    MENU_LINKS.splice(1);

    var storedPermissions = sessionStorage.getItem('SCE_Platform|user_roles');
    if (storedPermissions) {
      var permissions = JSON.parse(storedPermissions);
      if (permissions.indexOf('Admin') >= 0) {
        MENU_LINKS.push({
          icon: 'icon-chart',
          title: 'Admin',
          badge: 'true',
          active: 'false',
          children: [
            { title: 'User Management', path: ['/admin/userManagement'] },
            { title: 'Role Management', path: ['/admin/roleManagement'] }
          ]
        });
      };
      if (sessionStorage.getItem('SCE_Platform|sso_user') == "false") {
        MENU_LINKS.push({ icon: 'icon-chart', title: 'Change Password', path: ['/change-password'], badge: '' });
      }
      if (permissions.indexOf('Configuration') >= 0) {
        MENU_LINKS.push({
          icon: 'icon-chart',
          title: 'Configuration',
          badge: 'true',
          active: 'false',
          children: [
            { title: 'Message Center', path: ['/configuration/message-center'] },
            { title: 'Setup', path: ['/configuration/setup'] },
            { title: 'Emergency OptOut', path: ['/configuration/emergencyOptOut'] },
            { title: 'Device OptOut Set', path: ['/configuration/deviceOptOutSet'] },
            { title: 'ABANK Maintenance', path: ['/configuration/abankMaintenance'] },
            { title: 'BBANK Maintenance', path: ['/configuration/substationMaintenance'] },
            { title: 'LCG Maintenance', path: ['/configuration/lcgMaintenance'] },
            { title: 'LCG Mapping Maintenance', path: ['/configuration/lcgMapMaintenance'] },
            { title: 'SLAP Maintenance', path: ['/configuration/slapMaintenance'] },
            { title: 'TX Off-Air Monitors', path: ['/configuration/txOffAirMonitors'] },
            { title: 'Device Monitors', path: ['/configuration/deviceMonitors'] }
          ]
        });
      };
      if ((permissions.indexOf('Dispatch') >= 0) || (permissions.indexOf('Curtailment') >= 0)) {
        MENU_LINKS.push({
          icon: 'icon-chart',
          title: 'Curtailment',
          badge: 'true',
          active: 'false',
          children: [
            { title: 'View/Edit Curtailments', path: ['/curtailment/curtailments'] },
            { title: 'New Curtailment', path: ['/curtailment/newCurtailment'] },
          ]
        });
      };
      if (permissions.indexOf('Status') >= 0) {
        MENU_LINKS.push({
          icon: 'icon-chart',
          title: 'Status',
          badge: 'true',
          active: 'false',
          children: [
            { title: 'Transmitter Status', path: ['/status/transmitterStatus'] },
            { title: 'Transmission Queue', path: ['/status/transmissionQueue'] },
            { title: 'Console Logger', path: ['/status/cseConsoleLogViewer'] },
            { title: 'Decoder Logger', path: ['/status/cseDecodeLogger'] },
            { title: 'LCG SLAP ABANK BBANK', path: ['/status/lcgSlapAbank'] },
            { title: "Device Monitor", path: ['/status/deviceMonitor'] }
          ]
        });
      };
      if (permissions.indexOf('Reporting') >= 0) {
        MENU_LINKS.push({
          icon: 'icon-chart',
          title: 'Reporting',
          badge: 'true',
          active: 'false',
          children: [
            { title: 'Logon History', path: ['/reporting/logonHistory'] },
            { title: 'Snap File Validation', path: ['/reporting/snapFileValidation'] },
            { title: 'TX Backlog', path: ['/reporting/txBacklog'] },
            { title: 'Tx Status History', path: ['/reporting/txStatusHistory'] }
          ]
        });
      };
    }
  }
}
